export const GET_DIAGRAMS = 'sagas/cause/GET_DIAGRAMS';
export const GET_PROJECT_DIAGRAMS = 'sagas/cause/GET_PROJECT_DIAGRAMS';
